<template>
  <div>
    <ConditionsGenerales />
  </div>
</template>

<script>
import ConditionsGenerales from '@/components/CguDoc.vue'

export default {
  components: { ConditionsGenerales }
}
</script>